module.exports = __webpack_public_path__ + "img/42_49.d12fba1c.png";